export const CATEGORIES = {
  body: { label: 'Тіло',          color: 'var(--cat-body)', hex: '#F2C4B0' },
  mind: { label: 'Розум',         color: 'var(--cat-mind)', hex: '#B8D4C8' },
  skin: { label: 'Шкіра',         color: 'var(--cat-skin)', hex: '#E4C5D3' },
  anti: { label: 'Анти-звички',   color: 'var(--cat-anti)', hex: '#C5CAE9' },
};

export const DEFAULT_TASKS = [
  // Body — 4 tasks
  { id: 'body-1', label: 'Ранкова розтяжка 10 хв',  category: 'body', isAnti: false },
  { id: 'body-2', label: 'Прогулянка 30 хв',         category: 'body', isAnti: false },
  { id: 'body-3', label: 'Випити 2л води',            category: 'body', isAnti: false },
  { id: 'body-4', label: 'Прийняти вітаміни',         category: 'body', isAnti: false },
  // Mind — 3 tasks
  { id: 'mind-1', label: 'Медитація 10 хв',           category: 'mind', isAnti: false },
  { id: 'mind-2', label: 'Щоденник',                  category: 'mind', isAnti: false },
  { id: 'mind-3', label: 'Читати 20 сторінок',         category: 'mind', isAnti: false },
  // Skin — 3 tasks
  { id: 'skin-1', label: 'Ранковий догляд',            category: 'skin', isAnti: false },
  { id: 'skin-2', label: 'Оновити SPF',                category: 'skin', isAnti: false },
  { id: 'skin-3', label: 'Вечірнє очищення та сироватка', category: 'skin', isAnti: false },
  // Anti — 3 tasks
  { id: 'anti-1', label: 'Без телефону до 8:00',       category: 'anti', isAnti: true },
  { id: 'anti-2', label: 'Без кофеїну після 14:00',    category: 'anti', isAnti: true },
  { id: 'anti-3', label: 'Лягти спати до 22:30',       category: 'anti', isAnti: true },
];
